import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const VisCtx = createContext({ map: {}, get: () => null, refresh: () => {} });

export function VisibilityProvider({ children }) {
  const [map, setMap] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/visibility");
      setMap(data || {});
    } catch (_) { /* keep current */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const get = (key) => map[key] || { state: "visible" };

  return (
    <VisCtx.Provider value={{ map, get, refresh }}>{children}</VisCtx.Provider>
  );
}

export const useVisibility = () => useContext(VisCtx);
